import matchSorter from 'match-sorter';
export function getKey(itemToString, item) {
  if (typeof item === 'string') return item;
  if (item.id) return item.id;
  if (itemToString) return itemToString(item);
  return item;
}
export function renderItem(itemToString, item) {
  if (itemToString) return itemToString(item);
  return item;
}
export function reorderItems(items, inputValue, itemToString) {
  if (inputValue) {
    const options = {
      keys: itemToString ? [itemToString] : undefined
    };
    return matchSorter(items, inputValue, options);
  }

  return items;
}